<div class="relative inline-block text-left select-none">
  <!-- Trigger Button -->
  <button
    type="button"
    (click)="toggleDropdown()"
    class="flex items-center gap-2 text-xs md:text-sm font-semibold text-text-primary hover:text-text-primary px-3 py-1.5 rounded-sm hover:bg-card-bg-hover transition-colors cursor-pointer"
  >
    <span>{{ displayLabel() }}</span>
    @if (loading) {
      <div class="w-3.5 h-3.5 border-2 border-primary/20 border-t-primary rounded-full animate-spin shrink-0"></div>
    } @else {
      <svg
        class="w-3.5 h-3.5 text-text-half-dimmed transition-transform duration-200 shrink-0"
        [class.rotate-180]="isOpen()"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" />
      </svg>
    }
  </button>

  <!-- Dropdown Popover Container -->
  @if (isOpen()) {
    <div
      [class]="'absolute top-full mt-2 z-50 bg-combobox-panel-bg border border-combobox-panel-border shadow-2xl rounded-2xl p-5 flex flex-col sm:flex-row gap-5 max-w-[calc(100vw-2rem)] sm:min-w-[480px] ' + (align === 'right' ? 'right-0' : 'left-0')"
      (click)="$event.stopPropagation()"
    >
      <!-- LEFT COLUMN: Preset Options -->
      <div class="flex flex-col gap-1.5 sm:w-36 shrink-0 border-b sm:border-b-0 sm:border-r border-combobox-panel-border pb-3 sm:pb-0 sm:pr-4 pt-1">
        @for (preset of presets; track preset.id) {
          <button
            type="button"
            (click)="selectPreset(preset, $event)"
            [class]="selectedPreset() === preset.id
              ? 'px-3 py-2 text-xs font-bold text-text-primary bg-combobox-list-item-hover-bg rounded-lg text-left transition-colors cursor-pointer border-l-2 border-text-brand'
              : 'px-3 py-2 text-xs font-medium text-text-half-dimmed hover:text-text-primary hover:bg-combobox-list-item-hover-bg/60 rounded-lg text-left transition-colors cursor-pointer border-l-2 border-transparent'"
          >
            {{ preset.label }}
          </button>
        }
      </div>

      <!-- RIGHT COLUMN: Interactive Calendar & Apply Button -->
      <div class="flex-1 flex flex-col min-w-[260px]">
        <!-- Calendar Header (Month/Year & Prev/Next navigation) -->
        <div class="flex items-center justify-between pb-3">
          <button
            type="button"
            (click)="prevMonth($event)"
            class="p-1 rounded-md text-text-half-dimmed hover:text-text-primary hover:bg-combobox-list-item-hover-bg transition-colors cursor-pointer"
            title="Previous month"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <span class="text-xs font-bold text-text-primary tracking-wide">
            {{ monthYearLabel() }}
          </span>

          <button
            type="button"
            (click)="nextMonth($event)"
            [disabled]="isNextMonthDisabled()"
            class="p-1 rounded-md text-text-half-dimmed hover:text-text-primary hover:bg-combobox-list-item-hover-bg disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-text-half-dimmed transition-colors cursor-pointer"
            title="Next month"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <!-- Days of Week Headers (S M T W T F S) -->
        <div class="grid grid-cols-7 text-center text-[11px] font-bold text-text-dimmed mb-1">
          <span>S</span>
          <span>M</span>
          <span>T</span>
          <span>W</span>
          <span>T</span>
          <span>F</span>
          <span>S</span>
        </div>

        <!-- Calendar Days Grid -->
        <div class="grid grid-cols-7 gap-y-1 text-center">
          @for (dayObj of calendarDays(); track $index) {
            <div class="h-8 flex items-center justify-center relative">
              @if (dayObj.isCurrentMonth) {
                <div
                  (click)="onDayClick(dayObj, $event)"
                  (mouseenter)="onDayMouseEnter(dayObj)"
                  (mouseleave)="onDayMouseLeave()"
                  [class]="getDayClass(dayObj)"
                >
                  {{ dayObj.dayNumber }}
                </div>
              }
            </div>
          }
        </div>

        <!-- Apply Button -->
        <button
          type="button"
          (click)="applyRange($event)"
          class="w-full mt-4 py-2 bg-button-primary-default hover:bg-button-primary-hover text-text-inverted-primary font-bold text-xs rounded-xl transition-colors shadow-md cursor-pointer"
        >
          Apply
        </button>
      </div>
    </div>
  }
</div>
